<template>
  <div class="remain-dialog-container">
    <div class="remain-dialog-content">
      <div class="header-title">{{ title }}</div>
      <div class="content">
        <div class="desc" v-html="desc"></div>
        <div class="rights-list">
          <div
            v-for="(item, index) in rightsListData"
            :key="index"
            class="rights-item"
          >{{ item.title }}</div>
        </div>
        <div class="footer">
          <div class="footer-item" @click="handleCancelRights">{{ cancelBtnText }}</div>
          <div class="footer-item" @click="handleConfirmRights">{{ confirmBtnText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'rights'
    },
    rightsListData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '确认取消「精选求职包」吗？'
    },
    desc: {
      type: String,
      default: '知己知彼，百战不怠！<br />求职前做足准备能大大提升拿到Offer的几率哦！'
    },
    cancelBtnText: {
      type: String,
      default: '残忍放弃'
    },
    confirmBtnText: {
      type: String,
      default: '去拿Offer'
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleCancelRights() {
      this.$emit('handleCancelRights', this.type)
    },
    handleConfirmRights() {
      const ids = this.rightsListData.map(item => item.id)
      this.$emit('handleConfirmRights', ids, {}, this.type)
    }
  }
}
</script>
<style lang="scss" scoped>
.remain-dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: .6);
  .remain-dialog-content {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.13);
    width: 360px;
    .header-title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 84px;
      color: #fff;
      border-radius: 8px 8px 0 0;
      font-size: 20px;
      font-weight: 600;
      background-image: url('https://logo.wondercv.com/banners/h6Axy2Ln19646Lo.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .content {
      padding: 24px 32px 32px;
      .desc {
        text-align: center;
        font-size: 14px;
        line-height: 24px;
        color: #404040;
        white-space: nowrap;
      }
      .rights-list {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 24px 0;
        .rights-item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 142px;
          height: 32px;
          color: #ff6644;
          border: 1px solid rgba($color: #FF6644, $alpha: 0.2);
          background-color: #FFF5F3;
          box-sizing: border-box;
        }
      }
      .footer {
        display: flex;
        align-items: center;
        .footer-item {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 18px;
          height: 36px;
          background: linear-gradient(to bottom, #FF9F79, #FF6644);
          color: #fff;
          font-weight: 500;
          cursor: pointer;
          &:first-child {
            margin-right: 16px;
            color: #9C9C9C;
            background: #EEEEEE;
          }
        }
      }
    }
  }
}
</style>